var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_33639)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_616_33639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 11H11.5V77H77.5V11H18.8333ZM70.1667 18.3333V69.6667H18.8333V18.3333H70.1667ZM33.5 25.6667H26.1667V33H33.5V25.6667ZM55.5 25.6667H62.8333V33H55.5V25.6667ZM33.5 55H26.1667V62.3333H33.5V55ZM55.5 55H62.8333V62.3333H55.5V55ZM48.1667 40.3333H40.8333V47.6667H48.1667V40.3333Z",
    fill: "#30D689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7292 18.3333V16.7708H70.1667H18.8333H17.2708V18.3333V69.6667V71.2292H18.8333H70.1667H71.7292V69.6667V18.3333ZM13.0625 12.5625H18.8333H75.9375V75.4375H13.0625V12.5625ZM27.7292 31.4375V27.2292H31.9375V31.4375H27.7292ZM57.0625 27.2292H61.2708V31.4375H57.0625V27.2292ZM27.7292 60.7708V56.5625H31.9375V60.7708H27.7292ZM57.0625 56.5625H61.2708V60.7708H57.0625V56.5625ZM42.3958 46.1042V41.8958H46.6042V46.1042H42.3958Z",
    stroke: "#30D689",
    strokeWidth: 3.125
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_616_33639",
    x: -1.21186,
    y: -1.71186,
    width: 91.4237,
    height: 91.4237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.35593
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.839216 0 0 0 0 0.537255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_616_33639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_616_33639",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_33639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.1bbf98813d31f6cac332643f02e8e8bf.svg";
export { ForwardRef as ReactComponent };